import dataLayerPush from './DataLayer';

export default function lineItem(dataJsonString: string) {
  const data = JSON.parse(dataJsonString);
  return {
    data,
    normalizeQuantity(input: HTMLInputElement) {
      const element = input;
      const min = Number.parseFloat(element.min);
      const max = Number.parseFloat(element.max);
      const value = Number.parseFloat(element.value);
      let normalizedValue = value;

      if (!Number.isNaN(min) && (Number.isNaN(normalizedValue) || normalizedValue < min)) {
        normalizedValue = min;
      }

      if (!Number.isNaN(max) && !Number.isNaN(normalizedValue) && normalizedValue > max) {
        normalizedValue = max;
      }

      if (!Number.isNaN(normalizedValue)) {
        element.value = String(normalizedValue);
      }
    },
    updateCart(event: string) {
      dataLayerPush({
        event,
        ecommerce: {
          currency: 'EUR',
          value: this.data.price,
          items: [{
            item_brand: 'Driessen stoffen',
            ...this.data,
          }],
        },
      });
    },
  };
}
